import { Fragment } from "react";

type SemanticPhrasesProps = Readonly<{
  phrases: readonly [string, ...string[]];
  forceBreakAfter?: readonly number[];
}>;

export function SemanticPhrases({
  phrases,
  forceBreakAfter = [],
}: SemanticPhrasesProps) {
  const forcedBreaks = new Set(forceBreakAfter);

  return (
    <>
      {phrases.map((phrase, index) => (
        <Fragment key={`${index}-${phrase}`}>
          <span className="semantic-phrase">{phrase}</span>
          {index < phrases.length - 1 ? (
            forcedBreaks.has(index) ? (
              <br aria-hidden="true" />
            ) : (
              <wbr />
            )
          ) : null}
        </Fragment>
      ))}
    </>
  );
}
